import BackgroundIconsAnimations from './background-icons-animations';

const ThankYou = () => {
  return (
    <section
      id="thank-you-section"
      className="flex min-h-screen w-full items-center justify-center  overflow-hidden bg-brand-800 px-4 py-24 sm:px-8 md:px-12 lg:px-20"
    >
      <BackgroundIconsAnimations hideIcons={true} />
      <div className="mx-auto flex h-full items-center justify-center">
        <div className="flex flex-col items-center justify-center  px-10 text-brand-50 md:px-10 lg:px-[123px]">
          <h2 className="title-animation mb-[94px] text-center text-3xl/snug font-normal md:text-4xl/snug lg:text-5xl/snug">
            <p className="font-medium">Thank you!</p>
            Your Demo request has been received.
          </h2>
          <p className="image-animation mb-14 text-center text-xl text-brand-100 lg:text-2xl/snug">
            A Mindsite expert will be in touch with you as soon as possible.
            <br />
            During the demo, we will be listening your needs and showcase the
            capabilities of our solution.
          </p>
          <p className="image-animation text-center text-[32px] font-normal text-orange-300">
            We are excited to show you how much Mindsite can help you!{' '}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ThankYou;
